import React from 'react';

import AvatarComponent from '@/components/common-components/AvatarComponent/AvatarComponent';
import ShortString from '@/components/common-components/ShortString/ShortString';

interface Props {
  profileLink?: string;
  name: string;
  className?: string;
  avatarSize?: number;
  stringLength?: number;
}

const ProfileChip: React.FC<Props> = ({ profileLink, name, className, avatarSize = 20, stringLength = 8 }) => {
  return (
    <div className={`profile-chip ${className}`}>
      <AvatarComponent src={profileLink} alt={name} size={avatarSize} />
      <ShortString name={name} stringLength={stringLength} />
    </div>
  );
};

export default ProfileChip;
